var React = require('react');

function IconSms (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 0C6.79375 0 5 1.79375 5 4V28C5 30.2062 6.79375 32 9 32H23C25.2062 32 27 30.2062 27 28V4C27 1.79375 25.2062 0 23 0H9ZM14 27H18C18.55 27 19 27.45 19 28C19 28.55 18.55 29 18 29H14C13.45 29 13 28.55 13 28C13 27.45 13.45 27 14 27Z","fill":"currentColor"}));
}

IconSms.defaultProps = {"viewBox":"0 0 32 32","fill":"currentColor"};

module.exports = IconSms;

IconSms.default = IconSms;
